export default "__VITE_ASSET__D0U2zzIL__"